import { RpcError } from 'grpc-web'

export function isGrpcError(err: unknown): err is RpcError {
  return (
    err !== null &&
    typeof err === 'object' &&
    (err as RpcError).code !== undefined &&
    (err as RpcError).message !== undefined
  )
}
